import { CellListElement } from 'commons/components';
import { TooltipedCustomFieldCell } from 'commons/components/table/components/TooltipedCustomFieldCell.component';
import { TooltipedMoreIndicatorStyled } from 'commons/components/table/custom-table.style';
import { TrackedEventGroup } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.model';
import {
    countEvents,
    formatGroupsForTooltip,
} from 'modules/settings/pods/settings-operator-custom-notifications/components/tracked-events-by-model-cell/tracked-events-by-model-cell.business';
import { EMPTY_CELL } from 'modules/settings/pods/settings-operator-custom-notifications/components/tracked-events-by-model-cell/tracked-events-by-model-cell.constants';

interface TrackedEventsByModelCellProps {
    groups: TrackedEventGroup[];
}

export const TrackedEventsByModelCell: React.FC<TrackedEventsByModelCellProps> = ({ groups }) => {
    const total = countEvents(groups);

    if (total === 0) {
        return <>{EMPTY_CELL}</>;
    }

    const [firstGroup] = groups;

    if (total === 1) {
        return <TooltipedCustomFieldCell value={firstGroup.eventLabels[0]} />;
    }

    return (
        <CellListElement>
            <TooltipedCustomFieldCell value={firstGroup.eventLabels[0]} />
            <CellListElement>
                <TooltipedMoreIndicatorStyled
                    value={`+${total - 1}`}
                    tooltipText={formatGroupsForTooltip(groups)}
                    showTooltipAlways
                />
            </CellListElement>
        </CellListElement>
    );
};
